module.exports = new __parcel__URL__("level_6_tab_inactive.1884a67b.png").toString();